import { CAMPAIGN_NODES, PLAYER } from '../data';

export function getProgressData() {
  // Process unlock queue
  PLAYER.unlockQueue.forEach(nodeId => {
    const nodeIndex = CAMPAIGN_NODES.findIndex(node => node.id === nodeId);
    if (nodeIndex !== -1) {
      // Mark previous node as completed
      if (nodeIndex > 0) {
        CAMPAIGN_NODES[nodeIndex - 1].completed = true;
      }
      // Set this as the current active node
      PLAYER.currentCampaignNode = nodeId;
    }
  });

  // Track nodes that were just removed from unlock queue
  const unlockedNodes = [...PLAYER.unlockQueue];
  const previouslyUnlockedNodes = CAMPAIGN_NODES
    .filter(node => node.justUnlocked)
    .map(node => node.id);

  // Clear the unlock queue after processing
  PLAYER.unlockQueue = [];

  const nodes = CAMPAIGN_NODES.map((node, index) => ({
    ...node,
    x: 135,
    y: 80 + index * 160,
    active: node.id === PLAYER.currentCampaignNode,
    justUnlocked: unlockedNodes.includes(node.id),
    fadeOut: previouslyUnlockedNodes.includes(node.id) && !unlockedNodes.includes(node.id),
    elements: node.elements
  }));

  const maxY = Math.max(...nodes.map(node => node.y));
  const totalHeight = maxY + 200;

  return { nodes, totalHeight };
}

export function onLeaveNode({ isVictory = true, progressPercentage = 1.0 } = {}, app, nodeId) {
  try {
    const currentNodeIndex = CAMPAIGN_NODES.findIndex(node => node.id === nodeId);
    const node = CAMPAIGN_NODES[currentNodeIndex];
    if (!node) {
      console.error(`No battle node found for nodeId: ${nodeId}`);
      app.goToProgress();
      return;
    }

    // unlock next node if this node is completed
    if (isVictory && !node.completed) {
      node.completed = true;
      const nextNode = CAMPAIGN_NODES[currentNodeIndex + 1];
      if (nextNode && !nextNode.completed) {
        if (!PLAYER.unlockQueue.includes(nextNode.id)) {
          PLAYER.unlockQueue.push(nextNode.id);
        }
      }
    }

    // Silently add rewards without showing screen
    let battleRewards = node.rewards;
    if (battleRewards) {
      if (!isVictory && progressPercentage > 0) {
        battleRewards = {
          currency: Math.floor(battleRewards.currency * progressPercentage),
          premiumCurrency: Math.floor(battleRewards.premiumCurrency * progressPercentage)
        };
      }

      // Add rewards directly to player
      if (battleRewards.currency) {
        PLAYER.resources.currency += battleRewards.currency;
      }
      if (battleRewards.premiumCurrency) {
        PLAYER.resources.premiumCurrency += battleRewards.premiumCurrency;
      }
    } else {
      console.error(`No reward found for node ${nodeId}`);
    }

    // Go directly to progress screen
    app.goToProgress();
  } catch (error) {
    console.error('Error in handleFinishBattle:', error);
    app.goToProgress(); // Fallback to progress screen on error
  }
}

export function onEnterNode(app, node) {
  if (node.chapterId) {
    app.goToStory(
      node.chapterId,
      (success) =>
        onLeaveNode({ isVictory: success, progressPercentage: success ? 1 : 0 }, app, node.id)
    );
  } else if (node.gameType) {
    app.goToGame(
      node.gameType,
      node.levelId,
      (result) => {
        onLeaveNode({ isVictory: result.isVictory, progressPercentage: result.progressPercentage }, app, node.id);
      }
    );
  } else {
    throw new Error("Invalid node missing chapterId and gameType + levelId");
  }
}